import Lottie from "lottie-react";

import brightLightLoadingAnimation from "~/assets/bright-light.json";
import lightLoadingAnimation from "~/assets/light.json";
import darkLoadingAnimation from "~/assets/dark.json";
import mediumLoadingAnimation from "~/assets/medium.json";
import fullMediumLoadingAnimation from "~/assets/full-medium.json";
import beyondDarkLoadingAnimation from "~/assets/beyond-dark.json";

const animations = {
  "bright-light": brightLightLoadingAnimation,
  light: lightLoadingAnimation,
  medium: mediumLoadingAnimation,
  "full-medium": fullMediumLoadingAnimation,
  dark: darkLoadingAnimation,
  "beyond-dark": beyondDarkLoadingAnimation,
};

const LoadingAnimation = ({ roastLevel, pdp }) => {
  const animationData = animations[roastLevel];

  return animationData ? (
    <Lottie
      className="absolute left-1/2 -top-1 custom-translate-x-50 w-[105%] z-1 rounded-md"
      animationData={animationData}
      loop={false}
    />
  ) : null;
};

export default LoadingAnimation;
